<template>
  <div class="mt-1 mb-1">
    <b-alert v-if="!elegivel" show variant="warning" class="mb-0">
      <strong>Pagamento à vista</strong>
      <div>
        O valor total do pedido está abaixo do mínimo de {{ minimoFormatado }}.
        A opção ficará disponível ao atingir esse valor.
      </div>
    </b-alert>
    <b-form-checkbox v-else v-model="pagamentoAVista" :value="1" :unchecked-value="0" :disabled="disabled">
      Pagamento à vista
    </b-form-checkbox>
  </div>
</template>

<script>
import { BAlert, BFormCheckbox } from 'bootstrap-vue';

// Estado exclusivamente visual: não persiste nem participa do payload do pedido.
export default {
  name: 'PagamentoAVistaVisual',
  components: { BAlert, BFormCheckbox },
  props: {
    total: { type: Number, required: true },
    valorMinimo: { type: Number, required: true },
    disabled: { type: Boolean, default: false },
  },
  data: () => ({ selecionado: 0 }),
  computed: {
    elegivel() {
      return Number.isFinite(this.total) && Number.isFinite(this.valorMinimo)
        && this.total >= Math.max(0, this.valorMinimo);
    },
    pagamentoAVista: {
      get() {
        // Retorna zero imediatamente, mesmo antes do watcher executar.
        return !this.disabled && this.elegivel && this.selecionado === 1 ? 1 : 0;
      },
      set(value) {
        this.selecionado = !this.disabled && this.elegivel && value === 1 ? 1 : 0;
        this.$emit('change', this.selecionado === 1);
      },
    },
    minimoFormatado() {
      return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' })
        .format(Number.isFinite(this.valorMinimo) ? Math.max(0, this.valorMinimo) : 0);
    },
  },
  watch: {
    elegivel(value) {
      if (!value) this.reset();
    },
    disabled(value) {
      if (value) this.reset();
    },
  },
  beforeDestroy() {
    this.reset();
  },
  methods: {
    reset() {
      this.selecionado = 0;
      this.$emit('change', false);
    },
  },
};
</script>